import { defineStore } from "pinia";
import _ from "lodash";
import { FetchState } from "@/shared/types";
import { FiservCodeMappingRequest, FiservCodeMappingResponse, FiservCodeMappingState } from "@/admin/types";
import * as storeHelper from "@/shared/storeHelper";
import * as fiservCodeMappingsService from "@/shared/api/fiservCodeMappingsService";


export const initialState: FiservCodeMappingState = {
    mappingsFetchState: FetchState.Uninitialized,
    mappings: []
};

export const useFiservCodeMappingStore = defineStore("FiservCodeMapping", {
    state: () => (_.cloneDeep(initialState)),
    getters : {
        mappingsInProgress: state => state.mappingsFetchState === FetchState.Loading
    },
    actions : {
        setMappingsFetchState (fetchState: FetchState) {
            this.mappingsFetchState = fetchState;
        },
        setMappings (mappings: FiservCodeMappingResponse[]) {
            this.mappings = mappings;
        },
        getFiservCodeMappings () {
            this.setMappingsFetchState(FetchState.Loading);
            return fiservCodeMappingsService.getFiservCodeMappings()
               .then(response => {
                    this.setMappings(response.data);
                    this.setMappingsFetchState(FetchState.Loaded);
               })
               .catch(err => storeHelper.handleError({error: err, rethrow: true}));
        },
        createFiservCodeMapping (fiservCodeMappingRequest: FiservCodeMappingRequest) {
            this.setMappingsFetchState(FetchState.Loading);
            return fiservCodeMappingsService.createFiservCodeMapping(fiservCodeMappingRequest)
               .then(response => {
                    this.getFiservCodeMappings();
               })
               .catch(err => storeHelper.handleError({error: err, rethrow: true}));
        },
        updateFiservCodeMapping (fiservCodeMappingId: number, fiservCodeMappingRequest: FiservCodeMappingRequest) {
            this.setMappingsFetchState(FetchState.Loading);
            return fiservCodeMappingsService.updateFiservCodeMapping(fiservCodeMappingId, fiservCodeMappingRequest)
               .then(response => {
                    this.getFiservCodeMappings();
               })
               .catch(err => storeHelper.handleError({error: err, rethrow: true}));
        },
        deleteFiservCodeMapping (fiservCodeMappingId: number) {
            this.setMappingsFetchState(FetchState.Loading);
            return fiservCodeMappingsService.deleteFiservCodeMapping(fiservCodeMappingId)
               .then(response => {
                    this.getFiservCodeMappings();
               })
               .catch(err => storeHelper.handleError({error: err, rethrow: true}));
        }
    }
});